import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import CustomerCareContainer from 'app/containers/CustomerCare'

const CustomerCarePageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.customer_care)}</PageTitle>
      <CustomerCareContainer />
    </>
  )
}
const CustomerCarePage = memo(CustomerCarePageCpn, isEqual)

export default CustomerCarePage
